import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { Button, type ButtonProps } from '@/components/ui/button';

export interface SaveButtonProps extends Omit<ButtonProps, 'children'> {
  /** When true, shows spinner and "Sparar..." label */
  isSaving: boolean;
  /** Button label when not saving. Default: "Spara" */
  children?: React.ReactNode;
  /** Label shown during save. Default: "Sparar..." */
  savingLabel?: string;
}

/**
 * Standardised save button with spinner state.
 * Automatically disabled while saving.
 */
export function SaveButton({
  isSaving,
  children = 'Spara',
  savingLabel = 'Sparar...',
  disabled,
  ...props
}: SaveButtonProps) {
  return (
    <Button disabled={disabled || isSaving} {...props}>
      {isSaving ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          {savingLabel}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
